import { Promise } from 'es6-promise';
import * as GoogleMapsLoader from 'google-maps';
import { GoogleTools } from './Data';

export const LoadMaps = (): Promise<GoogleTools> => {
  return new Promise<GoogleTools>(resolve => {
    console.log('Creating promise to load Google maps asynchronously');

    // TODO - unload?
    // TODO: GoogleMapsLoader.REGION = 'IE'; >> not released yet?
    (GoogleMapsLoader as any).KEY = 'AIzaSyDPmaK_ZeZzYITQHT9KpftobsXIz3r8SWo';
    (GoogleMapsLoader as any).VERSION = '3.37';
    (GoogleMapsLoader as any).LIBRARIES = ['geometry', 'places'];

    GoogleMapsLoader.load(g => {
      console.log('Google maps loaded', g);

      resolve({
        AutoComplete: new google.maps.places.AutocompleteService(),
        GeoCoder: new google.maps.Geocoder()
      });
    });
  });
};

export default LoadMaps;
